// removed by extract-text-webpack-plugin
module.exports = {"toggleSwitch":"_1eY-cD4I0gwvPUofrVJO76","activeSwitch":"_2Nug5BH2yH5RA4mXna6lwu","knob":"_2cPzs4YInv-7WXHPbxw6X2","activePoint":"_3iStpVo64ClAE8UEyyh0V"};


//////////////////
// WEBPACK FOOTER
// ./src/react/ui/features/InputSwitch.styl
// module id = 742
// module chunks = 0